import { ProfileResponsibleManagersWidgetForm } from '../../ProfileResponsibleManagersWidgetForm'
import { useWidgetContext } from '../../Widget.hooks'
import { WidgetContentItemsList } from '../../WidgetContentItemsList'

function ProfileResponsibleManagersWidgetContent({
  formProps: { onClose, onSuccess, ...restFormProps },
  items,
  listProps,
}) {
  const { handleDisableEditMode, isEditMode } = useWidgetContext()

  function handleClose() {
    handleDisableEditMode()
    onClose?.()
  }

  function handleSuccess() {
    handleDisableEditMode()
    onSuccess?.()
  }

  return (
    <>
      {items?.length > 0 ? (
        <WidgetContentItemsList {...listProps} items={items} />
      ) : null}
      {isEditMode ? (
        <ProfileResponsibleManagersWidgetForm
          {...restFormProps}
          onClose={handleClose}
          onSuccess={handleSuccess}
        />
      ) : null}
    </>
  )
}

export default ProfileResponsibleManagersWidgetContent
